import * as Yup from 'yup';
import YupPassword from 'yup-password';
import Schema from './Schema';
YupPassword(Yup);
export const passwordValidator = () => (Yup.string().minLowercase(1, 'Must contain at least 1 lower case letter')
    .minUppercase(1, 'Must contain at least 1 upper case letter')
    .minNumbers(1, 'Must contain at least 1 number')
    .minSymbols(1, 'Must contain at least 1 special character')
    .min(8, 'Must be at least 8 characters')
    .required('Required'));
export const fieldValidator = (fieldName, field, required) => {
    // eslint-disable-next-line no-prototype-builtins
    if (field.hasOwnProperty('subtype') && field.subtype === 'email') {
        return Yup.string().email('Must be a valid email address in the format \'name@domain.tld\'');
    }
    if (field.type === 'string') {
        let validator = Yup.string();
        if (field.wordRequired)
            validator = validator.matches(/[a-zA-Z]/, `${field.label} cannot consist only from numbers. Please, add words`);
        if (field.maxLength)
            validator = validator.max(field.maxLength, `Must be ${field.maxLength} characters or less`);
        if (field.minLength)
            validator = validator.min(field.minLength, `Must be ${field.minLength} characters or more`);
        if (field.validation === 'password') {
            // todo - these could be added as individual requirements
            validator = passwordValidator();
        }
        else if (field.validation === 'slug') {
            validator = validator.matches(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug must only contain lowercase letters, numbers, and hyphens, and cannot start or end with a hyphen');
        }
        if (required)
            validator = validator.required('Required');
        // Make optional string fields nullable to match GraphQL schema (string | null)
        if (!required)
            validator = validator.nullable();
        if (field.regex)
            validator = validator.matches(new RegExp(field.regex), field.regexFailMessage ? field.regexFailMessage : `Field must match regex: ${field.regex}`);
        return validator;
    }
    // throw `Fields of type ${field.type} not supported`;
    return null;
};
/** Model Validator */
export default (modelName) => {
    const model = Schema.getModel(modelName);
    const customRules = {};
    // if (modelName === 'membership') {
    //   const validator = Yup.number();
    //   customRules.recurringPrice =
    // validator.required('Required when membership type is recurring');
    // }
    return Yup.object(Schema.getPropertyList(modelName).reduce((validatorObject, propName) => {
        // don't validate id
        if (propName === 'id')
            return validatorObject;
        const fv = fieldValidator(propName, model.properties[propName], model.required && model.required.includes(propName));
        if (fv)
            validatorObject[propName] = fv;
        return validatorObject;
    }, customRules));
};
//# sourceMappingURL=YupAdapter.js.map